<template>
  <div class="dk-editar-page">

    <!-- ── Modal Embed ──────────────────────────────── -->
    <el-dialog
      :visible.sync="dialogTableVisible"
      :before-close="closeModal"
      custom-class="dk-embed-dialog"
      width="520px"
    >
      <div class="dk-embed-modal">
        <div class="dk-embed-modal__header">
          <feather-icon icon="CodeIcon" size="20" class="dk-embed-modal__icon" />
          <div>
            <h5 class="dk-embed-modal__title">Código de incorporação</h5>
            <p class="dk-embed-modal__sub">{{ embedCode.name }}</p>
          </div>
        </div>

        <div class="dk-embed-modal__tabs">
          <button class="dk-embed-tab" @click="simples">
            <feather-icon icon="ZapIcon" size="13" class="mr-50" />Simples
          </button>
          <button class="dk-embed-tab" @click="javascript">
            <feather-icon icon="CodeIcon" size="13" class="mr-50" />JS Completo
          </button>
          <button class="dk-embed-tab" @click="iframe">
            <feather-icon icon="FramerIcon" size="13" class="mr-50" />Iframe
          </button>
          <button class="dk-embed-tab" @click="link">
            <feather-icon icon="LinkIcon" size="13" class="mr-50" />Link
          </button>
        </div>

        <div class="dk-embed-modal__code-wrap">
          <textarea id="texto" readonly class="dk-embed-modal__textarea">{{ embedCode.embed }}</textarea>
          <button class="dk-embed-modal__copy-btn" @click="copiarTexto()">
            <feather-icon icon="CopyIcon" size="15" />
          </button>
        </div>

        <div class="dk-embed-modal__footer">
          <button class="dk-embed-modal__close-btn" @click="dialogTableVisible = false">Fechar</button>
        </div>
      </div>
    </el-dialog>

    <!-- ── Sidebar ───────────────────────────────────── -->
    <aside class="dk-editar-sidebar">

      <button class="dk-sidebar-back" @click="Voltar">
        <feather-icon icon="ArrowLeftIcon" size="14" class="dk-sidebar-back__icon" />
        <span>Meus Vídeos</span>
      </button>

      <div class="dk-sidebar-divider" />

      <!-- Miniatura + nome do vídeo -->
      <div v-if="vsl && vsl.length" class="dk-sidebar-video-info">
        <div class="dk-sidebar-thumb">
          <feather-icon icon="VideoIcon" size="18" class="dk-sidebar-thumb__icon" />
        </div>
        <div class="dk-sidebar-video-info__text">
          <span class="dk-sidebar-video-info__name">{{ vsl[0].vsl_name }}</span>
          <span class="dk-sidebar-video-info__label">VSL</span>
        </div>
      </div>

      <div class="dk-sidebar-divider" />

      <nav class="dk-sidebar-nav">
        <button
          v-for="item in navItems"
          :key="item.key"
          class="dk-sidebar-item"
          :class="{ 'dk-sidebar-item--active': activeNav === item.key }"
          @click="navigate(item)"
        >
          <span class="dk-sidebar-item__icon-wrap">
            <feather-icon :icon="item.icon" size="16" />
          </span>
          <div class="dk-sidebar-item__text">
            <span class="dk-sidebar-item__label">{{ item.label }}</span>
            <span class="dk-sidebar-item__sub">{{ item.sub }}</span>
          </div>
          <feather-icon icon="ChevronRightIcon" size="14" class="dk-sidebar-item__arrow" />
        </button>
      </nav>
    </aside>

    <!-- ── Área principal ─────────────────────────────── -->
    <main class="dk-editar-main">

      <!-- Cabeçalho: título + botão embed -->
      <div class="dk-editar-header">
        <div v-if="vsl && vsl.length" class="dk-editar-header__title-group">
          <span class="dk-editar-header__title">{{ vsl[0].vsl_name }}</span>
          <button class="dk-editar-header__edit-btn" @click="esconderNome(); ajusteCSS();">
            <feather-icon icon="Edit3Icon" size="14" />
          </button>
        </div>
        <div class="dk-editar-header__actions">
          <button class="dk-btn-test" @click="abrirTestePage">
            <feather-icon icon="ExternalLinkIcon" size="14" class="mr-50" />
            Testar ao vivo
          </button>
          <button class="dk-btn-embed" @click="Embed">
            <feather-icon icon="CodeIcon" size="14" class="mr-50" />
            Embed
          </button>
        </div>
      </div>

      <!-- Formulário de edição (oculto por padrão) -->
      <div class="dk-editar-form" hidden>
        <div class="dk-form-fields" v-if="vsl && vsl.length">
          <div class="dk-form-field">
            <label class="dk-form-label">Nome do vídeo</label>
            <input v-model="vsl[0].vsl_name" class="dk-form-input" placeholder="Nome do vídeo" />
          </div>
          <div class="dk-form-field">
            <label class="dk-form-label">Descrição</label>
            <textarea v-model="vsl[0].vsl_description" class="dk-form-input dk-form-textarea" placeholder="Descrição do vídeo" />
          </div>
          <div class="dk-form-field">
            <label class="dk-form-label">Tag</label>
            <input v-model="vsl[0].vsl_tag" class="dk-form-input" placeholder="Tag" />
          </div>
          <div class="dk-form-actions">
            <button class="dk-btn-save" @click="updateInfoVSL">
              <feather-icon icon="CheckIcon" size="14" class="mr-50" />
              Salvar
            </button>
            <button class="dk-btn-cancel" @click="cancelar(); voltarCSS();">
              Cancelar
            </button>
          </div>
        </div>
      </div>

      <!-- Player Shell -->
      <div class="dk-player-shell">

        <div class="dk-player-badge-row">
          <span class="dk-player-badge">
            <feather-icon icon="PlayIcon" size="11" class="mr-25" />
            Preview do player
          </span>
        </div>

        <player-preview-iframe
          :vsl-id="vslId"
          :thumb-src="frameVsl"
          :orientation="vsl[0] && vsl[0].orientation ? vsl[0].orientation : 'Horizontal'"
        />

      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios'
import { VslService, Vsl_Service } from '@/services/Vsl'
import EmbedModal from '@/services/embedModal'
import router from '@/router'
import Detalhes from './Detalhes.vue'
import PlayerPreviewIframe from '@/components/player/PlayerPreviewIframe.vue'

const vslService = new Vsl_Service()

export default {
  components: {
    Detalhes,
    PlayerPreviewIframe,
  },
  data() {
    return {
      frameVsl: '',
      embedCode: { name: 'Codigo Simples', embed: '' },
      dialogTableVisible: false,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      vslId: this.$route.params.vslId,
      options: {},
      vsl: [],
      activeNav: 'detalhes',
      navItems: [
        { key: 'detalhes',   label: 'Detalhes',   sub: 'Nome, descrição e tag',         icon: 'FileTextIcon',     action: 'irDetalhes' },
        { key: 'editar',     label: 'Editar',      sub: 'Personalizar player e estilo',  icon: 'SlidersIcon',      action: 'customizacao' },
        { key: 'pixels',     label: 'Pixels',      sub: 'Facebook, Google, TikTok',      icon: 'CrosshairIcon',    action: 'pixels' },
        { key: 'analytics',  label: 'Analytics',   sub: 'Métricas e retenção',           icon: 'BarChart2Icon',    action: 'analitycs' },
        { key: 'download',   label: 'Download',    sub: 'Baixar arquivo de vídeo',       icon: 'DownloadCloudIcon',action: 'download' },
      ],
    }
  },
  async created() {
    try {
      const response = await VslService.getVsl(this.vslId)
      this.vsl = response.data
    } catch (error) {
      this.errorMessage = error
    }
  },
  beforeCreate() {
    this.$http.get('/perfil_geral').then(res => {
      this.options = res.data
    })
  },
  mounted() {
    this.vslobjId()
  },
  methods: {
    navigate(item) {
      this.activeNav = item.key
      if (this[item.action]) this[item.action]()
    },
    async vslobjId() {
      const vslObj = await vslService.getVslId(this.vslId)
      this.frameVsl = vslObj[0].vsl_frame
    },
    abrirTestePage() {
      // A rota test-page é servida diretamente pelo API server.
      // Em produção, o Caddy faz proxy de /test-page/* para o api-server.
      // Em dev, apontamos direto para a porta do API server.
      const origin = window.location.origin
      const testUrl = origin + '/test-page/' + this.vslId
      window.open(testUrl, '_blank')
    },
    async Embed() {
      const item = {
        id: this.vslId,
        orientation: this.vsl[0]?.orientation || 'Horizontal',
        vsl_frame: this.frameVsl,
        videoGroupId: this.vsl[0]?.videoGroupId || null,
        vsl_bucket_address: this.vsl[0]?.vsl_bucket_address || '',
        vsl_url: this.vsl[0]?.vsl_url || '',
      }
      localStorage.setItem('itemEmbed', JSON.stringify(item))
      localStorage.setItem('itemEmbedPaired', '')
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal('Codigo Simples')
      this.dialogTableVisible = true
    },
    async simples() {
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal('Codigo Simples')
    },
    async javascript() {
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal('Codigo JS')
    },
    async iframe() {
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal('Codigo Iframe')
    },
    async link() {
      const embedModal = new EmbedModal()
      this.embedCode = await embedModal.embedModal('Link')
    },
    closeModal(done) {
      this.dialogTableVisible = false
      localStorage.removeItem('itemEmbed')
      if (done) done()
    },
    copiarTexto() {
      const textoCopiado = document.getElementById('texto')
      textoCopiado.select()
      textoCopiado.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.$message({ message: 'Código copiado para área de transferência', type: 'success' })
    },
    esconderNome() {
      const nome = document.querySelector('.dk-editar-header__title-group')
      const formulario = document.querySelector('.dk-editar-form')
      nome && nome.setAttribute('hidden', '')
      formulario && formulario.removeAttribute('hidden')
    },
    ajusteCSS() {
      const iniciar = document.querySelector('.iniciar')
      if (!iniciar) return
      const cor = iniciar.getAttribute('style') || ''
      iniciar.setAttribute('style', `height:36%;${cor}top:53%;`)
    },
    voltarCSS() {
      const iniciar = document.querySelector('.iniciar')
      if (!iniciar) return
      iniciar.removeAttribute('style')
      iniciar.setAttribute('style', `height:43%;top:32%;`)
    },
    cancelar() {
      const nome = document.querySelector('.dk-editar-header__title-group')
      const formulario = document.querySelector('.dk-editar-form')
      formulario && formulario.setAttribute('hidden', '')
      nome && nome.removeAttribute('hidden')
    },
    updateInfoVSL() {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id_vsl: this.vslId,
          vsl_name: this.vsl[0].vsl_name,
          vsl_description: this.vsl[0].vsl_description,
          vsl_tag: this.vsl[0].vsl_tag,
        }),
      }
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/updateInfoVSL`, options)
        .then(response => response.json())
        .then(response => {
          if (response.affectedRows === 1) {
            this.$message({ type: 'success', message: 'Salvo com sucesso' })
            this.cancelar()
          } else {
            this.$alert('Não foi possível alterar os dados')
          }
        })
        .catch(err => console.error(err))
    },
    irDetalhes() {},
    customizacao() {
      this.$router.push(`/player/${this.vslId}/estilo`)
    },
    pixels() {
      this.$router.push(`/videos/pixels/${this.vslId}`)
    },
    analitycs() {
      this.$router.push(`/player/${this.vslId}/analytics`)
    },
    Voltar() {
      this.$router.push({ name: 'Meus-Videos' })
    },
    download() {
      if (!this.vsl || !this.vsl[0]) return
      axios({
        method: 'get',
        url: this.vsl[0].vsl_bucket_address,
        responseType: 'arraybuffer',
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.vsl[0].vsl_name || 'video'}.mp4`)
          document.body.appendChild(link)
          link.click()
        })
        .catch(() => console.log('Erro no download'))
    },
  },
}
</script>

<style lang="scss" scoped>
/* ─── Variáveis ──────────────────────────────────── */
$navy:    #0D3349;
$orange:  #E86A10;
$gold:    #F5B935;
$border:  #DDE3EA;
$bg:      #F4F6F9;
$text:    #3D4A5C;
$muted:   #8A98A8;
$white:   #ffffff;
$dark:    #0a1520;

/* ─── Layout raiz ────────────────────────────────── */
.dk-editar-page {
  display: flex;
  gap: 24px;
  min-height: calc(100vh - 140px);
  align-items: flex-start;
  padding: 8px 0 40px;
}

/* ─── Sidebar ─────────────────────────────────────── */
.dk-editar-sidebar {
  width: 264px;
  flex-shrink: 0;
  background: $white;
  border: 1px solid $border;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba($navy, 0.06);
  overflow: hidden;
  position: sticky;
  top: 80px;
}

/* Botão voltar */
.dk-sidebar-back {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 16px 20px;
  background: none;
  border: none;
  font-size: 13px;
  font-weight: 500;
  color: $muted;
  cursor: pointer;
  transition: color 0.15s;
  text-align: left;

  &:hover {
    color: $navy;
    .dk-sidebar-back__icon { color: $orange; }
  }
}
.dk-sidebar-back__icon {
  color: $muted;
  transition: color 0.15s;
  flex-shrink: 0;
}

.dk-sidebar-divider {
  height: 1px;
  background: $border;
}

/* Info do vídeo */
.dk-sidebar-video-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: rgba($navy, 0.02);
}
.dk-sidebar-thumb {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba($navy, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  color: $muted;
  flex-shrink: 0;
}
.dk-sidebar-thumb__icon { color: $muted; }
.dk-sidebar-video-info__text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dk-sidebar-video-info__name {
  font-size: 12.5px;
  font-weight: 600;
  color: $text;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dk-sidebar-video-info__label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: $orange;
}

/* Nav items */
.dk-sidebar-nav {
  padding: 8px 0 12px;
}
.dk-sidebar-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 20px;
  background: none;
  border: none;
  border-left: 3px solid transparent;
  cursor: pointer;
  transition: all 0.15s;
  text-align: left;

  &:hover {
    background: rgba($navy, 0.03);
    border-left-color: rgba($orange, 0.3);
    .dk-sidebar-item__label { color: $navy; }
    .dk-sidebar-item__icon-wrap { background: rgba($orange, 0.1); color: $orange; }
    .dk-sidebar-item__arrow { opacity: 1; transform: translateX(2px); }
  }

  &--active {
    background: rgba($navy, 0.04);
    border-left-color: $orange;
    .dk-sidebar-item__label { color: $navy; font-weight: 700; }
    .dk-sidebar-item__icon-wrap { background: rgba($orange, 0.12); color: $orange; }
    .dk-sidebar-item__arrow { opacity: 1; }
  }
}
.dk-sidebar-item__icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba($navy, 0.05);
  color: $muted;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s;
}
.dk-sidebar-item__text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dk-sidebar-item__label {
  font-size: 13px;
  font-weight: 600;
  color: $text;
  transition: color 0.15s;
  line-height: 1.2;
}
.dk-sidebar-item__sub {
  font-size: 11px;
  color: $muted;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dk-sidebar-item__arrow {
  color: $muted;
  opacity: 0;
  flex-shrink: 0;
  transition: all 0.15s;
}

/* ─── Área principal ──────────────────────────────── */
.dk-editar-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Cabeçalho ── */
.dk-editar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: $white;
  border: 1px solid $border;
  border-radius: 14px;
  padding: 14px 20px;
  box-shadow: 0 1px 6px rgba($navy, 0.05);
}
.dk-editar-header__title-group {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.dk-editar-header__title {
  font-size: 16px;
  font-weight: 700;
  color: $navy;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dk-editar-header__edit-btn {
  background: none;
  border: 1px solid $border;
  border-radius: 8px;
  padding: 5px 8px;
  cursor: pointer;
  color: $muted;
  display: flex;
  align-items: center;
  transition: all 0.15s;
  flex-shrink: 0;
  &:hover { color: $orange; border-color: $orange; }
}
.dk-editar-header__actions { display: flex; gap: 8px; align-items: center; }

/* Botão Testar ao vivo */
.dk-btn-test {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background: transparent;
  color: $orange;
  border: 1.5px solid $orange;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s;
  white-space: nowrap;
  &:hover { background: rgba($orange, 0.08); }
}

/* Botão Embed */
.dk-btn-embed {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background: $navy;
  color: $white;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: lighten($navy, 8%); }
}

/* ── Formulário de edição ── */
.dk-editar-form {
  background: $white;
  border: 1px solid $border;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 1px 6px rgba($navy, 0.05);
}
.dk-form-fields { display: flex; flex-direction: column; gap: 14px; }
.dk-form-field { display: flex; flex-direction: column; gap: 6px; }
.dk-form-label { font-size: 12px; font-weight: 600; color: $muted; text-transform: uppercase; letter-spacing: 0.05em; }
.dk-form-input {
  border: 1px solid $border;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  color: $text;
  background: $white;
  outline: none;
  transition: border-color 0.15s;
  width: 100%;
  &:focus { border-color: $orange; }
}
.dk-form-textarea { min-height: 80px; resize: vertical; }
.dk-form-actions { display: flex; gap: 10px; margin-top: 4px; }
.dk-btn-save {
  display: inline-flex;
  align-items: center;
  padding: 9px 20px;
  background: $orange;
  color: $white;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
  &:hover { opacity: 0.9; }
}
.dk-btn-cancel {
  padding: 9px 20px;
  background: none;
  border: 1px solid $border;
  border-radius: 10px;
  font-size: 13px;
  color: $muted;
  cursor: pointer;
  transition: all 0.15s;
  &:hover { border-color: $text; color: $text; }
}

/* ─── Player Shell ────────────────────────────────── */
.dk-player-shell { display: flex; flex-direction: column; gap: 10px; }
.dk-player-badge-row { display: flex; }
.dk-player-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: $muted;
  background: $bg;
  border: 1px solid $border;
  border-radius: 20px;
  padding: 4px 12px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}


/* ─── Modal Embed ─────────────────────────────────── */
.dk-embed-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 0;
}

.dk-embed-modal__header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dk-embed-modal__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(232, 106, 16, 0.10);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: $orange;
}
.dk-embed-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: $navy;
  margin: 0 0 2px;
  line-height: 1.2;
}
.dk-embed-modal__sub {
  font-size: 12px;
  color: $muted;
  margin: 0;
}

.dk-embed-modal__tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--dk-bg-segment, #f0f3f7);
  border-radius: 10px;
  padding: 4px;
}
.dk-embed-tab {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 16px;
  background: transparent;
  color: $muted;
  border: none;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  &:hover { background: var(--dk-bg-card, #fff); color: $navy; }
}
.dk-embed-tab--active {
  background: var(--dk-bg-card, #fff) !important;
  color: $navy !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.10);
}

.dk-embed-modal__code-wrap {
  position: relative;
}
.dk-embed-modal__textarea {
  width: 100%;
  min-height: 180px;
  background: #0d1b2a;
  color: var(--dk-text-faint, #a9c7e0);
  border: 1.5px solid rgba(255,255,255,0.08);
  border-radius: 12px;
  padding: 16px 52px 16px 16px;
  font-family: 'Fira Code', 'Courier New', monospace;
  font-size: 12.5px;
  line-height: 1.65;
  resize: vertical;
  outline: none;
  box-sizing: border-box;
  word-break: break-all;
  white-space: pre-wrap;
  transition: border-color 0.15s;
  &:focus { border-color: rgba($orange, 0.5); }
}
.dk-embed-modal__copy-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  background: rgba(255,255,255,0.10);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 8px;
  color: var(--dk-text-faint, #a9c7e0);
  cursor: pointer;
  transition: all 0.15s;
  &:hover { background: $orange; color: $white; border-color: $orange; }
}

.dk-embed-modal__footer {
  display: flex;
  justify-content: flex-end;
}
.dk-embed-modal__close-btn {
  display: inline-flex;
  align-items: center;
  padding: 9px 20px;
  background: var(--dk-bg-segment, #f0f3f7);
  color: $text;
  border: none;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  &:hover { background: #e2e8f0; color: $navy; }
}

/* legacy aliases (manter compatibilidade) */
.dk-embed-tab--active { background: $navy; }
.dk-embed-tag {
  background: rgba($gold, 0.15);
  color: darken($gold, 20%);
  border: 1px solid rgba($gold, 0.4);
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
</style>
